'use strict';

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = require('./prop-types');

var blacklist = (0, _keys2.default)(propTypes).reduce(function (a, key) {
  return [].concat((0, _toConsumableArray3.default)(a), (0, _toConsumableArray3.default)((0, _keys2.default)(propTypes[key])));
}, []);

module.exports = function (props) {
  var next = {};

  for (var key in props) {
    if (blacklist.includes(key)) continue;
    next[key] = props[key];
  }

  return next;
};


//////////////////
// WEBPACK FOOTER
// ./~/styled-system/dist/remove-props.js
// module id = 385
// module chunks = 168707334958949